// extracted by mini-css-extract-plugin
export var option = "CapabilitiesPicker-module__option___C5QbU";
export var optionTitle = "CapabilitiesPicker-module__optionTitle___wk+vy";
export var subtitle = "CapabilitiesPicker-module__subtitle___Lr7Ni";